function checkTargetBlank(targetBlank, targetButtonId) {// eslint-disable-line no-unused-vars
    if (targetBlank == 'True') {// eslint-disable-line eqeqeq
        $('#' + targetButtonId).attr('target', '_blank');
    }
}

function addRelParameter(rel, targetButtonId) {// eslint-disable-line no-unused-vars
    if (rel) {
        $('#' + targetButtonId).attr('rel', rel);
    }
}
function assignButtonSize(size, buttonId) {// eslint-disable-line no-unused-vars
    if (size === 'S') {
        $('#' + buttonId).addClass('mi-btn--small').removeClass('mi-btn--large');
    }
    else if (size === 'M') {
        $('#' + buttonId).removeClass('mi-btn--small mi-btn--large');
    }
    else if (size === 'L') {
        $('#' + buttonId).addClass('mi-btn--large').removeClass('mi-btn--small');
    }
}

function assignButtonColor(color, buttonId) {// eslint-disable-line no-unused-vars
    const classes = ' mi-btn--primary-color-01 mi-btn--primary-color-02 mi-btn--primary-color-03 mi-btn--primary-color-04 '
        + ' mi-btn--secondary-color-01 mi-btn--secondary-color-02 mi-btn--secondary-color-03 '
        /* DEPRECATED VALUES */
        + ' mi-btn--purple mi-btn--orange mi-btn--green mi-btn--gray mi-btn--dark-blue mi-btn--blue mi-btn--light-blue mi-btn--charcoal ';

    const classToBeAdded = 'mi-btn--' + color;

    if (classes.indexOf(classToBeAdded) > -1) {
        $('#' + buttonId).addClass(classToBeAdded).removeClass(classes.replace(classToBeAdded, ''));
    }
}
